import { ApplicationStateSteps } from '@contexts/Estate';
import { createContext, useContext } from 'react';
import { EstateApplicationCommandActions, EstateApplicationQueryActions } from '../../domain';
import { GqlEstateApplicationCommandActions, GqlEstateApplicationQueryActions } from '../gql';

type ApplicationContextStage = {
  currentState: ApplicationStateSteps,
  setCurrentState: (state: ApplicationStateSteps) => void
};

export const estateApplicationStageContext = createContext<ApplicationContextStage | null>(null);

type EstateApplicationActionsContextT = {
  estateApplicationCommandActions: EstateApplicationCommandActions;
  estateApplciationQueryActions: EstateApplicationQueryActions;
};

export const estateApplicationActionsDefaultValue: EstateApplicationActionsContextT = {
  estateApplicationCommandActions: GqlEstateApplicationCommandActions,
  estateApplciationQueryActions: GqlEstateApplicationQueryActions
};

export const estateApplicationActionsContext = createContext<EstateApplicationActionsContextT>(estateApplicationActionsDefaultValue);

export const useEstateApplicationActions = (): EstateApplicationActionsContextT => useContext(estateApplicationActionsContext);
